export default {
  url: 'https://self-service-api.revenue.co.ke/api/v1',
  // Endpoints
  // loginEndpoint: '/jwt/login',
  loginEndpoint: 'https://self-service-api.revenue.co.ke/api/v1/auth/login',
  registerEndpoint: 'https://self-service-api.revenue.co.ke/api/v1/auth/signup',
  // registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
